(function () {

  function initFurProduct(root) {

    const sections =
      root &&
      root.matches?.(
        '[data-fur-product]'
      )
        ? [root]
        : document.querySelectorAll(
            '[data-fur-product]'
          );


    sections.forEach(
      function (section) {

        if (
          section.dataset
            .furProductInitialized ===
          'true'
        ) {
          return;
        }


        section.dataset
          .furProductInitialized =
          'true';


        /* =================================================
           CORE ELEMENTS
        ================================================= */

        const purchase =
          section.querySelector(
            '[data-fur-product-purchase]'
          );


        const gallery =
          section.querySelector(
            '[data-fur-product-gallery]'
          );


        const productMedia =
          Array.from(
            section.querySelectorAll(
              '[data-fur-product-media]'
            )
          );


        const mobileDots =
          Array.from(
            section.querySelectorAll(
              '[data-fur-mobile-dot]'
            )
          );


        /* =================================================
           ZOOM ELEMENTS
        ================================================= */

        const zoomOverlay =
          section.querySelector(
            '[data-fur-zoom-overlay]'
          );


        const zoomMedia =
          section.querySelector(
            '[data-fur-zoom-media]'
          );


        const hoverCursor =
          section.querySelector(
            '[data-fur-hover-cursor]'
          );


        const hoverCursorText =
          section.querySelector(
            '[data-fur-hover-cursor-text]'
          );


        let zoomOpen =
          false;


        /* =================================================
           PURCHASE REQUIRED
        ================================================= */

        if (!purchase) {
          return;
        }


        const form =
          purchase.querySelector(
            '.fur-product__form'
          );


        const productJsonElement =
          purchase.querySelector(
            '[data-fur-product-json]'
          );


        const variantIdInput =
          purchase.querySelector(
            '[data-fur-variant-id]'
          );


        const optionInputs =
          purchase.querySelectorAll(
            '[data-fur-option-input]'
          );


        const priceContainer =
          purchase.querySelector(
            '[data-fur-price]'
          );


        const inventory =
          purchase.querySelector(
            '[data-fur-inventory]'
          );


        const inventoryText =
          purchase.querySelector(
            '[data-fur-inventory-text]'
          );


        const addButton =
          purchase.querySelector(
            '[data-fur-add-button]'
          );


        const addButtonText =
          purchase.querySelector(
            '[data-fur-add-button-text]'
          );


        const message =
          purchase.querySelector(
            '[data-fur-form-message]'
          );


        if (
          !form ||
          !productJsonElement ||
          !variantIdInput
        ) {
          return;
        }


        /* =================================================
           VARIANTS
        ================================================= */

        let variants =
          [];


        try {

          variants =
            JSON.parse(
              productJsonElement
                .textContent
            );

        } catch (error) {

          console.error(
            'THE FUR PRODUCT: Invalid variant JSON.',
            error
          );


          return;

        }


        /* =================================================
           STRETCH TEXT
        ================================================= */

        function setStretchText(
          element,
          text
        ) {

          if (!element) {
            return;
          }


          if (
            window.FurStretchLinks &&
            typeof window
              .FurStretchLinks
              .reset ===
              'function'
          ) {

            window
              .FurStretchLinks
              .reset(
                element,
                text
              );


            return;

          }


          element.textContent =
            text;

        }


        /* =================================================
           MONEY
        ================================================= */

        function formatMoney(
          cents
        ) {

          if (
            window.Shopify &&
            typeof window
              .Shopify
              .formatMoney ===
              'function'
          ) {

            return window
              .Shopify
              .formatMoney(
                cents,
                window.theme
                  ?.moneyFormat ||
                '${{amount}}'
              );

          }


          const currency =
            window.Shopify
              ?.currency
              ?.active ||
            'USD';


          try {

            return new Intl
              .NumberFormat(
                document
                  .documentElement
                  .lang ||
                'en',
                {
                  style:
                    'currency',

                  currency:
                    currency
                }
              )
              .format(
                cents / 100
              );

          } catch (error) {

            return (
              (
                cents / 100
              ).toFixed(2) +
              ' ' +
              currency
            );

          }

        }


        /* =================================================
           SELECTED OPTIONS
        ================================================= */

        function getSelectedOptions() {

          const selected =
            [];


          purchase
            .querySelectorAll(
              '[data-fur-option]'
            )
            .forEach(
              function (group) {

                const checked =
                  group
                    .querySelector(
                      '[data-fur-option-input]:checked'
                    );


                if (checked) {

                  selected.push(
                    checked.value
                  );

                }

              }
            );


          return selected;

        }


        /* =================================================
           CURRENT VARIANT
        ================================================= */

        function getCurrentVariant() {

          const selectedOptions =
            getSelectedOptions();


          return variants.find(
            function (variant) {

              if (
                !variant.options ||
                variant
                  .options
                  .length !==
                selectedOptions
                  .length
              ) {

                return false;

              }


              return variant
                .options
                .every(
                  function (
                    option,
                    index
                  ) {

                    return (
                      option ===
                      selectedOptions[
                        index
                      ]
                    );

                  }
                );

            }
          );

        }


        /* =================================================
           UPDATE SELECTED LABELS
        ================================================= */

        function updateSelectedLabels() {

          purchase
            .querySelectorAll(
              '[data-fur-option]'
            )
            .forEach(
              function (group) {

                const checked =
                  group
                    .querySelector(
                      '[data-fur-option-input]:checked'
                    );


                const label =
                  group
                    .querySelector(
                      '[data-fur-selected-option]'
                    );


                if (
                  checked &&
                  label
                ) {

                  label.textContent =
                    checked.value;

                }

              }
            );

        }


        /* =================================================
           UPDATE PRICE
        ================================================= */

        function updatePrice(
          variant
        ) {

          if (!priceContainer) {
            return;
          }


          if (!variant) {

            priceContainer.innerHTML =
              '<span class="fur-product__price-current">UNAVAILABLE</span>';


            return;

          }


          let html =
            '';


          if (
            variant
              .compare_at_price &&
            variant
              .compare_at_price >
            variant.price
          ) {

            html +=
              '<span class="fur-product__price-current fur-product__price-current--sale">' +
              formatMoney(
                variant.price
              ) +
              '</span>';


            html +=
              '<s class="fur-product__price-compare">' +
              formatMoney(
                variant
                  .compare_at_price
              ) +
              '</s>';

          } else {

            html +=
              '<span class="fur-product__price-current">' +
              formatMoney(
                variant.price
              ) +
              '</span>';

          }


          priceContainer.innerHTML =
            html;

        }


        /* =================================================
           UPDATE INVENTORY
        ================================================= */

        function updateInventory(
          variant
        ) {

          if (
            !inventory ||
            !inventoryText
          ) {
            return;
          }


          inventory.classList.remove(
            'is-low-stock',
            'is-sold-out'
          );


          if (!variant) {

            inventory.classList.add(
              'is-sold-out'
            );


            inventoryText.textContent =
              'UNAVAILABLE';


            return;

          }


          if (!variant.available) {

            inventory.classList.add(
              'is-sold-out'
            );


            inventoryText.textContent =
              'SOLD OUT';


            return;

          }


          const threshold =
            parseInt(
              purchase.dataset
                .lowStockThreshold ||
              '5',
              10
            );


          const quantity =
            Number(
              variant
                .inventory_quantity
            );


          if (
            variant
              .inventory_management &&
            Number.isFinite(
              quantity
            ) &&
            quantity > 0 &&
            quantity <=
              threshold
          ) {

            inventory.classList.add(
              'is-low-stock'
            );


            inventoryText.textContent =
              quantity +
              (
                quantity === 1
                  ? ' ITEM LEFT'
                  : ' ITEMS LEFT'
              );


            return;

          }


          inventoryText.textContent =
            'IN STOCK';

        }


        /* =================================================
           UPDATE ADD BUTTON
        ================================================= */

        function updateAddButton(
          variant
        ) {

          if (
            !addButton ||
            !addButtonText
          ) {
            return;
          }


          const defaultText =
            purchase.dataset
              .addText ||
            'ADD TO BAG';


          if (!variant) {

            addButton.disabled =
              true;


            setStretchText(
              addButtonText,
              'UNAVAILABLE'
            );


            return;

          }


          if (!variant.available) {

            addButton.disabled =
              true;


            setStretchText(
              addButtonText,
              'SOLD OUT'
            );


            return;

          }


          addButton.disabled =
            false;


          setStretchText(
            addButtonText,
            defaultText
          );

        }


        /* =================================================
           UPDATE URL
        ================================================= */

        function updateURL(
          variant
        ) {

          if (
            !variant ||
            !window.history ||
            !window.history
              .replaceState
          ) {
            return;
          }


          const url =
            new URL(
              window.location.href
            );


          url.searchParams.set(
            'variant',
            variant.id
          );


          window.history
            .replaceState(
              {},
              '',
              url.toString()
            );

        }


        /* =================================================
           VARIANT MEDIA

           Mobile only.
        ================================================= */

        function showVariantMedia(
          variant
        ) {

          if (
            !variant ||
            !variant
              .featured_media_id ||
            !gallery
          ) {
            return;
          }


          if (
            window.innerWidth >
            749
          ) {
            return;
          }


          const media =
            section.querySelector(
              '[data-media-id="' +
              variant
                .featured_media_id +
              '"]'
            );


          if (!media) {
            return;
          }


          gallery.scrollTo({
            left:
              media.offsetLeft,

            behavior:
              'smooth'
          });

        }


        /* =================================================
           MASTER UPDATE
        ================================================= */

        function updateProduct() {

          const variant =
            getCurrentVariant();


          updateSelectedLabels();

          updatePrice(
            variant
          );

          updateInventory(
            variant
          );

          updateAddButton(
            variant
          );


          if (variant) {

            variantIdInput.value =
              variant.id;


            updateURL(
              variant
            );


            showVariantMedia(
              variant
            );

          } else {

            variantIdInput.value =
              '';

          }

        }


        /* =================================================
           OPTION EVENTS
        ================================================= */

        optionInputs.forEach(
          function (input) {

            input.addEventListener(
              'change',
              updateProduct
            );

          }
        );


        /* =================================================
           AJAX ADD TO BAG
        ================================================= */

        form.addEventListener(
          'submit',
          async function (event) {

            event.preventDefault();


            if (
              !variantIdInput.value ||
              addButton.disabled
            ) {
              return;
            }


            if (message) {

              message.hidden =
                true;


              message.textContent =
                '';

            }


            const originalText =
              purchase.dataset
                .addText ||
              'ADD TO BAG';


            addButton.disabled =
              true;


            addButton.classList.add(
              'is-loading'
            );


            setStretchText(
              addButtonText,
              'ADDING...'
            );


            try {

              const formData =
                new FormData(
                  form
                );


              const root =
                window.Shopify
                  ?.routes
                  ?.root ||
                '/';


              const response =
                await fetch(
                  root +
                  'cart/add.js',
                  {
                    method:
                      'POST',

                    headers: {
                      Accept:
                        'application/json'
                    },

                    body:
                      formData
                  }
                );


              const data =
                await response
                  .json();


              if (!response.ok) {

                throw new Error(
                  data.description ||
                  data.message ||
                  'Unable to add this product.'
                );

              }


              addButton.classList.add(
                'is-added'
              );


              setStretchText(
                addButtonText,
                'ADDED TO BAG'
              );


              document.dispatchEvent(
                new CustomEvent(
                  'fur:cart-updated',
                  {
                    detail: {
                      item:
                        data
                    }
                  }
                )
              );


              window.setTimeout(
                function () {

                  addButton.classList.remove(
                    'is-added'
                  );


                  setStretchText(
                    addButtonText,
                    originalText
                  );


                  addButton.disabled =
                    false;

                },
                1300
              );


            } catch (error) {

              console.error(
                'THE FUR PRODUCT:',
                error
              );


              if (message) {

                message.textContent =
                  error.message;


                message.hidden =
                  false;

              }


              addButton.disabled =
                false;


              setStretchText(
                addButtonText,
                originalText
              );


            } finally {

              addButton.classList.remove(
                'is-loading'
              );

            }

          }
        );


        /* =================================================
           MOBILE SLIDER DOTS
        ================================================= */

        if (
          gallery &&
          mobileDots.length
        ) {

          function updateMobileDots() {

            if (
              window.innerWidth >
              749
            ) {
              return;
            }


            if (
              !productMedia.length
            ) {
              return;
            }


            const galleryRect =
              gallery
                .getBoundingClientRect();


            const center =
              galleryRect.left +
              galleryRect.width /
              2;


            let activeIndex =
              0;


            let nearest =
              Infinity;


            productMedia.forEach(
              function (
                slide,
                index
              ) {

                const rect =
                  slide
                    .getBoundingClientRect();


                const slideCenter =
                  rect.left +
                  rect.width /
                  2;


                const distance =
                  Math.abs(
                    center -
                    slideCenter
                  );


                if (
                  distance <
                  nearest
                ) {

                  nearest =
                    distance;


                  activeIndex =
                    index;

                }

              }
            );


            mobileDots.forEach(
              function (
                dot,
                index
              ) {

                dot.classList.toggle(
                  'is-active',
                  index ===
                    activeIndex
                );

              }
            );

          }


          gallery.addEventListener(
            'scroll',
            function () {

              window
                .requestAnimationFrame(
                  updateMobileDots
                );

            },
            {
              passive: true
            }
          );


          mobileDots.forEach(
            function (dot) {

              dot.addEventListener(
                'click',
                function () {

                  const index =
                    parseInt(
                      dot.dataset
                        .slideIndex,
                      10
                    );


                  const slide =
                    productMedia[
                      index
                    ];


                  if (!slide) {
                    return;
                  }


                  gallery.scrollTo({
                    left:
                      slide
                        .offsetLeft,

                    behavior:
                      'smooth'
                  });

                }
              );

            }
          );


          updateMobileDots();

        }


        /* =================================================
           ZOOM CURSOR
        ================================================= */

        function moveHoverCursor(
          event
        ) {

          if (!hoverCursor) {
            return;
          }


          hoverCursor.style.left =
            event.clientX +
            'px';


          hoverCursor.style.top =
            event.clientY +
            'px';

        }


        function showHoverCursor(
          text,
          event
        ) {

          if (
            !hoverCursor ||
            window.innerWidth <=
            749
          ) {
            return;
          }


          if (hoverCursorText) {

            hoverCursorText
              .textContent =
              text;

          }


          hoverCursor.classList.add(
            'is-visible'
          );


          if (event) {

            moveHoverCursor(
              event
            );

          }

        }


        function hideHoverCursor() {

          if (!hoverCursor) {
            return;
          }


          hoverCursor.classList.remove(
            'is-visible'
          );

        }


        /* =================================================
           OPEN PRODUCT ZOOM
        ================================================= */

        function openProductZoom(
          media,
          event
        ) {

          if (
            window.innerWidth <=
            749
          ) {
            return;
          }


          if (
            !zoomOverlay ||
            !zoomMedia
          ) {
            return;
          }


          const image =
            media.querySelector(
              'img'
            );


          if (!image) {
            return;
          }


          const zoomImage =
            document.createElement(
              'img'
            );


          zoomImage.src =
            image.currentSrc ||
            image.src;


          zoomImage.alt =
            image.alt ||
            '';


          zoomMedia.innerHTML =
            '';


          zoomMedia.appendChild(
            zoomImage
          );


          zoomOverlay.classList.add(
            'is-open'
          );


          zoomOverlay.setAttribute(
            'aria-hidden',
            'false'
          );


          document.documentElement
            .classList.add(
              'fur-product-zoom-open'
            );


          document.body
            .classList.add(
              'fur-product-zoom-open'
            );


          zoomOpen =
            true;


          showHoverCursor(
            'CLOSE',
            event
          );

        }


        /* =================================================
           CLOSE PRODUCT ZOOM
        ================================================= */

        function closeProductZoom() {

          if (!zoomOverlay) {
            return;
          }


          zoomOverlay.classList.remove(
            'is-open'
          );


          zoomOverlay.setAttribute(
            'aria-hidden',
            'true'
          );


          if (zoomMedia) {

            zoomMedia.innerHTML =
              '';

          }


          document.documentElement
            .classList.remove(
              'fur-product-zoom-open'
            );


          document.body
            .classList.remove(
              'fur-product-zoom-open'
            );


          zoomOpen =
            false;


          hideHoverCursor();

        }


        /* =================================================
           MEDIA ZOOM EVENTS
        ================================================= */

        productMedia.forEach(
          function (media) {

            const image =
              media.querySelector(
                'img'
              );


            if (!image) {
              return;
            }


            media.addEventListener(
              'pointerenter',
              function (event) {

                if (
                  window.innerWidth <=
                  749 ||
                  zoomOpen
                ) {
                  return;
                }


                showHoverCursor(
                  'ZOOM',
                  event
                );

              }
            );


            media.addEventListener(
              'pointermove',
              function (event) {

                if (
                  window.innerWidth <=
                  749 ||
                  zoomOpen
                ) {
                  return;
                }


                moveHoverCursor(
                  event
                );

              }
            );


            media.addEventListener(
              'pointerleave',
              function () {

                if (!zoomOpen) {

                  hideHoverCursor();

                }

              }
            );


            media.addEventListener(
              'click',
              function (event) {

                if (
                  window.innerWidth <=
                  749
                ) {
                  return;
                }


                openProductZoom(
                  media,
                  event
                );

              }
            );

          }
        );


        /* =================================================
           ZOOM OVERLAY
        ================================================= */

        if (zoomOverlay) {

          zoomOverlay.addEventListener(
            'pointermove',
            function (event) {

              if (!zoomOpen) {
                return;
              }


              showHoverCursor(
                'CLOSE',
                event
              );

            }
          );


          zoomOverlay.addEventListener(
            'click',
            function () {

              closeProductZoom();

            }
          );

        }


        /* =================================================
           ESCAPE CLOSE
        ================================================= */

        document.addEventListener(
          'keydown',
          function (event) {

            if (
              event.key ===
                'Escape' &&
              zoomOpen
            ) {

              closeProductZoom();

            }

          }
        );


        /* =================================================
           INITIAL
        ================================================= */

        updateProduct();

      }
    );

  }


  /* =========================================================
     NORMAL PAGE LOAD
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initFurProduct();

      }
    );

  } else {

    initFurProduct();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.matches?.(
          '[data-fur-product]'
        )
          ? event.target
          : event.target
              .querySelector?.(
                '[data-fur-product]'
              );


      if (!section) {
        return;
      }


      delete section.dataset
        .furProductInitialized;


      initFurProduct(
        section
      );

    }
  );

})();